"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _useBreakpoint = _interopRequireDefault(require("../use-breakpoint/use-breakpoint"));

// TODO: 6.x remove in favor of "useBreakpoint"
var useBreakpointDeprecated = function useBreakpointDeprecated(breakpoint, fallback) {
  (0, _react.useEffect)(function () {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      // eslint-disable-next-line no-console
      console.warn("The _use-breakpoint hook has been moved to a public module. Please update your imports to \"@amzn/meridian/use-breakpoint\"");
    }
  }, []);
  return (0, _useBreakpoint["default"])(breakpoint, fallback);
};

var _default = useBreakpointDeprecated;
exports["default"] = _default;